class Dropzone {
  existingFiles = [];

  constructor(el) {
    const _self = this;

    // Dropzone.
    $(el)
      .find(".dropzone__input")
      .on("change", function () {
        const inputEl = $(this);
        const dropzoneEl = inputEl.closest(".dropzone");
        const fileListEl = dropzoneEl.find(".dropzone__list");

        const files = inputEl[0].files;

        if (files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            _self.existingFiles.push(files[i]); // Add newly selected files to existingFiles
          }

          fileListEl.html("");

          for (let i = 0; i < _self.existingFiles.length; i++) {
            let fileHtml = "";

            if (dropzoneEl.hasClass("dropzone--image")) {
              fileHtml = `<div class="dropzone-file" data-index="${i}">
                <button type="button" class="dropzone-file__remove" title="Remove file">
                  <img src="${mapIcons.delete}" alt="Remove file">
                </button>
                <img class="dropzone-file__preview" src="${URL.createObjectURL(
                  _self.existingFiles[i]
                )}" alt="${_self.existingFiles[i].name}">
              </div>`;
            } else {
              fileHtml = `<div class="dropzone-file" data-index="${i}">
                <span class="dropzone-file__name">${_self.existingFiles[i].name}</span>
                <button type="button" class="dropzone-file__remove" title="Remove file">
                  <img src="${mapIcons.delete}" alt="Remove file">
                </button>
              </div>`;
            }

            fileListEl.append(fileHtml);
          }
        }
      });

    // Remove file.
    $(el).on("click", ".dropzone-file__remove", function () {
      const fileEl = $(this).closest(".dropzone-file");
      const fileIndex = fileEl.data("index");
      const dropzoneEl = fileEl.closest(".dropzone");
      const inputEl = dropzoneEl.find(".dropzone__input");

      let list = new DataTransfer();
      _self.existingFiles.splice(fileIndex, 1); // Remove file from existingFiles array

      for (let i = 0; i < _self.existingFiles.length; i++) {
        list.items.add(_self.existingFiles[i]);
      }

      inputEl[0].files = list.files;

      fileEl.remove();
    });
  }

  getExistingFiles() {
    return this.existingFiles;
  }
}

export default Dropzone;
